import { client } from "../../amplify-client";

const CACHE_TTL_MS = 5 * 60 * 1000;
const profileCache = new Map();

function isFresh(entry) {
  if (!entry) return false;
  return Date.now() - entry.cachedAt < CACHE_TTL_MS;
}

async function fetchProfileSummary(cognitoId) {
  try {
    const resp = await client.queries.getUserProfile({ cognitoId });
    if (resp?.errors?.length) {
      throw new Error(resp.errors.map((err) => err.message).join(", "));
    }

    const data = resp?.data || null;
    const summary = {
      cognitoId,
      profilePicture: data?.profilePicture || "",
      profileName: data?.profileName || data?.name || "",
      profile: data || null,
    };

    profileCache.set(cognitoId, { value: summary, cachedAt: Date.now() });
    return summary;
  } catch (error) {
    console.error("Failed to fetch profile summary:", { cognitoId, error });
    const fallback = { cognitoId, profilePicture: "", profileName: "", profile: null };
    profileCache.set(cognitoId, { value: fallback, cachedAt: Date.now() });
    return fallback;
  }
}

export async function getProfileSummaries(cognitoIds = []) {
  const uniqueIds = [...new Set((cognitoIds || []).filter(Boolean))];
  if (!uniqueIds.length) return new Map();

  const resolved = await Promise.all(
    uniqueIds.map(async (id) => {
      const cached = profileCache.get(id);
      if (isFresh(cached)) {
        return [id, cached.value];
      }
      const summary = await fetchProfileSummary(id);
      return [id, summary];
    })
  );

  return new Map(resolved);
}
